import { gql } from '@apollo/client'

export default gql`
  fragment SyllabusListProjectVideoComponent on ProductCourseProjectVideo {
    id
    title
    description
    videoId
  }
`
